import formatStory from "../format/ourStory";
import queryByDocType from "../queryByDocType";

export default async () => {
	const story = await queryByDocType("about_our_story");
	return story.map(formatStory);
};
